import React from "react";
import { Helmet } from "react-helmet";

const TutorMetas = () => {
  return (
    <div>
      <Helmet>
        <title>Find the Best Tutors | Search & Connect</title>
        <meta charSet="UTF-8" />
        <meta name="title" content="Find the Best Tutors | Search & Connect" />
        <meta
          name="description"
          content="Find and connect with experienced tutors for various subjects. Browse tutor profiles, compare skills, and choose the best match for your learning needs."
        />
        <meta
          name="keywords"
          content="tutors, online tutoring, find a tutor, private tutor, teaching, education, skills, subjects, tutoring services"
        />
        <meta
          property="article:published_time"
          content="2023-08-23T01:30:57+00:00"
        />
      </Helmet>
    </div>
  );
};

export default TutorMetas;
